// Utility for dynamic imports to reduce initial bundle size

export const loadCharts = () => import('recharts');

// Note: Google Maps is loaded via script tag, not module import

export const loadFormLibraries = () => import('react-hook-form');

// Preload critical components after initial load
export const preloadCriticalComponents = () => {
  // Preload likely next components after a short delay
  setTimeout(() => {
    import('../components/forms/DetailsForm');
    import('../components/booking/PriceEstimationPage');
  }, 2000);
  
  // Preload admin components if user seems engaged
  setTimeout(() => {
    import('../components/admin/SettingsPage');
    import('../components/admin/AnalyticsDashboard');
  }, 5000);
};

// Cache for loaded modules
const moduleCache = new Map();

export const loadModuleWithCache = async (moduleName: string, loader: () => Promise<any>) => {
  if (moduleCache.has(moduleName)) {
    return moduleCache.get(moduleName);
  }
  
  const module = await loader();
  moduleCache.set(moduleName, module);
  return module;
};
